var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 168,
    viewBox: "0 0 186 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 583",
    d: "M86.4644 166.263C82.8215 165.627 80.0641 162.89 79.1408 161.601C57.5712 134.61 17.5287 84.4298 5.58268 69.2149C2.41542 65.1809 0.229715 62.6166 1.32509 57.1397C2.0154 53.6882 4.8257 51.2749 7.80562 49.6941C15.7201 45.4957 19.3765 44.3641 27.4704 40.5204L88.2856 11.6774C90.6458 10.6118 94.7876 8.72608 97.5873 7.4089C103.164 4.7852 108.236 4.27094 113.029 9.2449C136.118 38.5022 182.406 97.1532 182.847 97.6987C184.946 100.297 185.325 103.403 184.666 106.639C183.608 111.841 179.184 114.221 175.054 116.67L95.4271 164.384C93.9574 165.275 90.1073 166.899 86.4644 166.263Z",
    fill: "#8255FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 584",
    d: "M33.0306 48.358L89.5289 21.5109C91.6439 20.556 95.3555 18.8661 97.8644 17.6858C102.862 15.3346 107.407 14.8738 111.703 19.3311C120.058 29.9192 130.805 42.8032 141.866 56.8187C152.794 70.5652 162.25 89.2278 175.711 100.764C176.736 101.642 176.693 103.268 175.579 104.032C150.24 121.406 117.886 140.149 91.8523 151.945C91.1367 152.27 90.3171 152.151 89.7326 151.626C59.8686 124.795 20.9565 71.7441 13.6892 61.7055C13.0281 60.7922 13.2647 59.5287 14.2053 58.9069C16.6434 57.2951 21.0279 54.4331 22.9054 53.4371C29.9978 49.6748 33.0306 48.358 33.0306 48.358Z",
    fill: "#6844CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 580",
    d: "M30.2537 47.1543C29.6683 46.0489 27.8757 43.056 25.3899 39.9262C22.3583 36.1093 23.8564 34.9079 25.6092 33.9669C26.2674 33.6135 28.2493 32.6507 30.9109 31.627C34.2378 30.3474 38.8765 27.4002 39.2576 22.8276C39.5828 18.9251 33.7638 14.9625 38.1685 12.7169C39.8814 11.8437 49.3306 7.62783 53.8411 5.62903C54.1772 5.44443 55.0543 5.06158 55.8735 5.00697C56.8974 4.93871 57.5345 5.37099 58.1034 5.9626C58.5585 6.43588 60.7923 9.08283 61.8523 10.3471C62.5971 11.2121 64.7427 12.9636 67.3664 13.0501C70.646 13.1582 74.3941 12.4374 77.3854 10.6355C84.8696 6.17622 87.9775 11.368 91.2785 18.2449",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 588",
    d: "M181.815 87.5643C183.178 88.2302 179.876 93.2501 152.474 109.902C137.908 118.754 108.125 136.443 98.8685 138.773C61.2772 126.552 40.469 87.1387 16.7352 58.011C15.9433 57.0391 16.2185 55.5862 17.3165 54.9811C46.9266 38.6641 76.1287 25.3491 105.853 11.4819C127.714 40.4574 148.562 71.3247 181.815 87.5643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 618",
    opacity: 0.08,
    d: "M175.281 94.3426L121.251 100.81L142.312 82.4727L163.403 77.0639L181.82 88.6316L175.281 94.3426Z",
    fill: "#222638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 586",
    d: "M25.6093 33.9669C20.8916 33.3749 23.1474 42.4493 23.1474 42.4493L26.0183 41.4753C26.0183 41.4753 30.3852 46.9386 30.6391 47.4181L32.7423 49.432C33.9623 50.6003 35.7847 50.8762 37.2959 50.1216L90.8198 23.3926C92.2325 22.6871 92.8639 21.0016 92.2079 19.5653C88.315 11.0421 84.2117 6.56827 77.3855 10.6355C74.3942 12.4374 70.6461 13.1582 67.3665 13.0501C64.7428 12.9636 62.5972 11.2121 61.8524 10.3471C60.7924 9.08283 58.5586 6.43588 58.1035 5.9626C57.5346 5.37099 56.8975 4.93871 55.8736 5.00697C55.0544 5.06158 54.1773 5.44443 53.8412 5.62903C49.3307 7.62783 39.8815 11.8437 38.1686 12.7169C36.0276 13.8085 35.9436 14.732 36.0066 15.0679C36.057 15.3366 36.4849 15.7925 36.6926 15.9869C38.2678 17.5841 39.8626 19.9492 39.6499 22.5017C39.2688 27.0743 34.238 30.3474 30.911 31.627C28.2494 32.6507 26.2675 33.6135 25.6093 33.9669Z",
    fill: "#222638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 579",
    d: "M181.815 87.5643C183.178 88.2302 179.876 93.2501 152.474 109.902C138.316 118.506 109.783 135.458 99.6946 138.541C99.1546 138.707 98.5796 138.681 98.0447 138.5C60.9875 125.98 40.3123 86.9578 16.7647 58.0472C15.9633 57.0633 16.2737 55.5816 17.395 54.9873C57.7512 33.5973 75.3619 25.6954 104.377 12.1703C105.232 11.7714 106.259 12.02 106.827 12.7745C128.336 41.3713 149.056 71.566 181.815 87.5643Z",
    stroke: "#222638",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 578",
    d: "M3.92871 56.8439C4.60585 60.0893 7.10601 63.1285 8.91688 65.4348C20.8629 80.6497 59.5955 128.551 81.165 155.543C82.0883 156.832 84.8457 159.568 88.4886 160.204C92.1315 160.84 95.9816 159.217 97.4512 158.325L176.733 111.443C178.481 110.406 180.409 109.214 182.029 107.657",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 577",
    d: "M28.1105 40.2168C21.358 43.4193 14.4135 46.1888 7.80562 49.6941C4.8257 51.2749 2.0154 53.6882 1.32509 57.1397C0.229715 62.6166 2.41542 65.1809 5.58268 69.2149C17.5287 84.4298 57.5712 134.61 79.1408 161.601C80.0641 162.89 82.8215 165.627 86.4644 166.263C90.1073 166.899 93.9574 165.275 95.4271 164.384L175.054 116.67C179.184 114.221 183.608 111.841 184.666 106.639C185.325 103.403 184.946 100.297 182.847 97.6987C182.801 97.6411 181.497 96.1455 180.512 94.8983M89.9365 10.9299C92.289 9.86188 95.3621 8.45581 97.5873 7.4089C103.164 4.7852 108.236 4.27094 113.029 9.2449C127.109 27.0865 152.462 59.1558 168.316 79.2381",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 10201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 600",
    d: "M38.2842 64.5132C56.3403 54.9202 63.7995 51.602 76.6936 45.5865",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 601",
    d: "M64.208 68.6728C86.3435 56.9126 95.4879 52.8447 111.295 45.4702",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 603",
    d: "M77.375 83.7814C99.5105 72.0211 108.655 67.9532 124.462 60.5787",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 609",
    d: "M76.6934 110.299C108.636 93.3277 121.832 87.4574 144.643 76.8156",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 602",
    d: "M68.6768 74.0217C84.3323 65.7042 90.7997 62.8271 101.979 57.6115",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 604",
    d: "M81.8438 89.1304C97.4993 80.8128 103.967 77.9358 115.146 72.7201",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 610",
    d: "M83.457 117.456C98.3542 109.542 104.508 106.804 115.146 101.841",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 877",
    d: "M47.4652 76.4737C46.7406 75.4966 47.0489 74.1044 48.1182 73.5244L56.6228 68.9117C57.4982 68.4369 58.5896 68.6786 59.1828 69.4785L64.8766 77.1572C65.6011 78.1343 65.2929 79.5266 64.2236 80.1065L55.719 84.7192C54.8435 85.194 53.7521 84.9524 53.1589 84.1524L47.4652 76.4737Z",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 878",
    d: "M60.8001 92.2274C60.0756 91.2503 60.3838 89.858 61.4531 89.2781L69.9577 84.6654C70.8332 84.1906 71.9246 84.4322 72.5178 85.2322L78.2115 92.9109C78.9361 93.888 78.6278 95.2802 77.5585 95.8602L69.0539 100.473C68.1785 100.948 67.0871 100.706 66.4939 99.906L60.8001 92.2274Z",
    stroke: "#DADDEB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 611",
    d: "M66.249 92.8651L70.5732 93.5571V84.389",
    stroke: "#8255FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 608",
    d: "M53.1646 77.1489L57.4888 77.8409V68.6729",
    stroke: "#8255FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 582",
    d: "M30.2666 47.3092C30.8038 48.3606 32.283 50.3208 33.3476 50.6554C34.5702 51.0397 38.1812 49.4587 40.2637 48.3606C55.958 40.0851 74.8283 31.2569 90.8282 23.5859C92.9558 22.5658 92.1224 19.3677 90.3968 17.5941",
    stroke: "#222638",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 587",
    d: "M35.4148 47.3821C33.6156 42.4494 30.925 38.644 28.2686 35.6074M42.341 27.1207C45.0932 24.051 43.1388 19.4086 41.3481 16.7405C40.9943 16.2133 41.1524 15.484 41.7263 15.2126C44.177 14.0535 49.4906 11.6325 53.5465 9.81531",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 10203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 885",
    d: "M144.874 9.94964C147.103 4.8966 153.006 2.60728 158.06 4.83631L164.288 7.58402C169.341 9.81305 171.631 15.7163 169.402 20.7694L142.268 82.2791L124.889 97.4408C122.333 99.6704 118.337 97.9074 118.26 94.5168L117.741 71.4594L144.874 9.94964Z",
    fill: "#F2EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 891",
    d: "M144.874 9.94964C147.103 4.89659 153.006 2.60728 158.06 4.83631L164.288 7.58402C169.341 9.81305 171.631 15.7163 169.402 20.7694L167.682 24.6673L143.186 13.7754L144.874 9.94964Z",
    fill: "#DFD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 617",
    d: "M121.421 71.5175L117.717 72.0246L117.823 71.033L138.163 24.924L162.779 35.7825L142.439 81.8916L142.055 82.7609L139.728 79.7045C138.341 77.8825 135.995 77.0384 133.759 77.5325C131.204 78.097 128.556 76.8873 127.342 74.5699C126.208 72.4068 123.84 71.1861 121.421 71.5175Z",
    fill: "#8255FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 886",
    d: "M156.834 32.7121L137.315 76.9598L142.401 81.9788L162.944 35.4077L156.834 32.7121Z",
    fill: "#6844CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 888",
    d: "M144.436 27.2431L124.889 71.5545L117.781 71.1186L138.325 24.5475L144.436 27.2431Z",
    fill: "#926BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 882",
    d: "M143.168 13.817L155.028 20.1418L167.696 24.6368L162.805 35.7233L150.138 31.2284L138.277 24.9036L143.168 13.817Z",
    fill: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 879",
    d: "M143.572 12.9021L118.228 70.3557C117.989 70.8953 117.874 71.481 117.889 72.0707L118.55 98.3537C118.592 100.044 120.583 100.922 121.86 99.8139L141.717 82.582C142.163 82.1954 142.517 81.7151 142.755 81.1754L168.099 23.7218",
    stroke: "#222638",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 612",
    d: "M118.461 90.339C118.461 90.339 119.987 92.1052 122.781 93.3377C125.575 94.5702 127.909 94.5066 127.909 94.5066",
    stroke: "#222638",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 616",
    d: "M121.91 99.6033L127.909 94.5066L122.781 93.3377L118.461 90.339L118.615 98.1188C118.649 99.8045 120.625 100.695 121.91 99.6033Z",
    fill: "#222638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 611_2",
    d: "M117.864 71.1074C119.714 71.979 121.843 72.2498 123.932 71.7788C124.689 71.6081 125.503 71.9556 125.783 72.6791V72.6791C127.381 76.7984 132.015 78.8428 136.135 77.2453V77.2453C136.858 76.9647 137.663 77.331 138.047 78.0052C139.053 79.7702 140.577 81.1118 142.345 81.9095",
    stroke: "#222638",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 889",
    opacity: 0.08,
    d: "M167.327 8.92444C167.327 8.92444 171.62 11.7166 170.298 18.7387L162.805 35.7233L156.695 33.0278L167.327 8.92444Z",
    fill: "#222638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 890",
    opacity: 0.08,
    d: "M136.844 77.2854C136.844 77.2854 138.858 78.9357 142.161 82.5223L121.251 100.431L119.763 99.7746L136.844 77.2854Z",
    fill: "#222638"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 880",
    d: "M162.805 35.7233C162.805 35.7233 157.685 34.5577 150.138 31.2284C142.59 27.899 138.277 24.9036 138.277 24.9036",
    stroke: "#222638",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 881",
    d: "M143.212 13.7167L144.471 10.8646C146.922 5.30623 153.416 2.78798 158.974 5.23991L163.373 7.18041C168.932 9.63235 171.45 16.126 168.998 21.6843L167.74 24.5365C167.74 24.5365 162.62 23.3709 155.073 20.0416C150.623 18.0787 147.297 16.2318 145.317 15.0465",
    stroke: "#222638",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 613",
    d: "M126.041 69.191L142.962 30.8331",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 615",
    d: "M155.375 36.5303L138.501 74.7842",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartWriting);
export default __webpack_public_path__ + "static/media/chart-writing.f7a9fb13e7443127dda4e7ad9f4b0985.svg";
export { ForwardRef as ReactComponent };